import { CHANNEL } from '../../features/templates/constants/messageTemplateKeys';

export const ROUTES = {
  ROOT: '/',
  TEMPLATES: '/templates',
  TEMPLATES_CREATE_EMAIL: '/templates/create/email',
  TEMPLATES_CREATE_SMS: '/templates/create/sms',
  TEMPLATES_CREATE_MMS: '/templates/create/mms',
  TEMPLATES_EDIT_EMAIL: '/templates/edit/email/:templateId',
  TEMPLATES_EDIT_SMS: '/templates/edit/sms/:templateId',
  TEMPLATES_EDIT_MMS: '/templates/edit/mms/:templateId',
  CAMPAIGNS: '/campaigns',
};

export function getTemplateEditRoute(channel, templateId) {
  const normalized = String(channel ?? '')
    .trim()
    .toLowerCase();
  const id = encodeURIComponent(String(templateId ?? ''));

  if (normalized === CHANNEL.SMS) return `/templates/edit/sms/${id}`;
  if (normalized === CHANNEL.MMS) return `/templates/edit/mms/${id}`;
  return `/templates/edit/email/${id}`;
}

export function getTemplateCreateRoute(channel) {
  const normalized = String(channel ?? '')
    .trim()
    .toLowerCase();

  if (normalized === CHANNEL.SMS) return ROUTES.TEMPLATES_CREATE_SMS;
  if (normalized === CHANNEL.MMS) return ROUTES.TEMPLATES_CREATE_MMS;
  return ROUTES.TEMPLATES_CREATE_EMAIL;
}
